<template>
  <v-card class="support-search pa-3">
    <v-card-title color="primary">
      <h2 class="headers text-left">
        {{
          `Couldn\'t find the answer to your question in our FAQs? Send us a support query and we’ll help you out.`
        }}
      </h2>
    </v-card-title>
    <v-card-text class="pb-0">
      <p>
        Your query will be forwarded to Kimberlin Education, who manages this
        platform. We will endeavour to respond to your query within 2 business
        days.<br /><br />
      </p>
      <v-text-field
        label="Phone Number"
        v-model="phone"
        v-validate="'required'"
        :error-messages="errors.collect('phone')"
        data-vv-name="phone"
        data-vv-as="phone"
        placeholder="Enter your phone number so we can get in touch with you"
        required
      >
      </v-text-field>
      <v-autocomplete
        ref="classLevel"
        name="classLevel"
        v-model="question_type"
        v-validate="'required'"
        :error-messages="errors.collect('question_type')"
        :items="questions"
        data-vv-name="question_type"
        data-vv-as="query type"
        label="Query type"
        placeholder="What does your query relate to?"
        required
      />
      <v-textarea
        v-model="message"
        v-validate="'required|max:500'"
        :error-messages="errors.collect('message')"
        data-vv-name="message"
        data-vv-as="how can we help"
        counter="500"
        label="How can we help you? Explain the query or issue you are experiencing. The more detail you can give us, the better! Include the device and web browser you are using"
        required
      />
      <file-upload-input
        ref="file"
        label="Attachments "
        placeholder="Upload a screenshot to help us see what the issue is"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="disabled || loading"
      >
        submit
        <v-icon small class="pl-2">send</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// import SearchSchool from '@/components/SearchSchool'
import Teacher from '@/modules/teacher/models/Teacher'
import User from '@/modules/user/models/User'
import Config from '@/modules/config/models/Config'

import { mapMutations } from 'vuex'

export default {
  name: 'SendQuestion',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    FileUploadInput: () => import('@/components/FileUploadInput')
  },
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      phone: null,
      question_type: null,
      message: null,
      loading: false,
      isSDECC: 0
    }
  },
  computed: {
    disabled() {
      if (!this.question_type) return true
      if (!this.message) return true
      return false
    }
  },
  mounted() {
    if (Config.value('isSDECC') == 1) {
      this.isSDECC = 1
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar', 'showSnackbar']),
    async submit() {
      // validate form
      let result = await this.$validator.validateAll()

      if (!result) return // there are errors

      const payload = {
        question_type: this.question_type,
        message: this.message,
        phone: this.phone,
        attachment: this.$refs.file.fileList
      }

      try {
        this.loading = true
        if (this.isSDECC == 0) {
          await Teacher.dispatch('sendSupportEmail', {
            payload: payload
          })
        } else {
          await User.dispatch('sendSupportEmail', {
            payload: payload
          })
        }

        this.loading = false
        this.showSnackbar('Thank you for sending us your question.')
        this.question_type = null
        this.message = null
      } catch (error) {
        this.loading = false
        this.showErrorSnackbar('There was an error.')
      }
    }
  }
}
</script>

<style lang="scss">
.support-search {
  .headers {
    color: var(--v-primary-base);
    text-align: center;
    font-size: 1.25em;
    word-break: normal !important;
  }
}
</style>
